import { ApiStatus } from 'Constants';
import { AUTH_SESSION } from 'Reducers/auth/types';
import { INITIALIZATION_ERROR } from 'Reducers/nav/types';
import { getAuthSession } from 'Utilities/session';
import { store } from 'Utilities/store';
import { updateConfig } from 'Services/config';
import { getPatient } from 'Services/patient';
const root = (pageCtx) => {
    return new Promise((resolve) => {
        const queryParams = pageCtx.query;
        const { country, app: appParam, appVersion, deviceManufacturer, deviceModel, osType, osVersion, product, } = queryParams || {};
        const compatibility = pageCtx.pathname !== '/reset-password';
        const app = appParam || product;
        updateConfig(compatibility, country, app, appVersion, deviceManufacturer, deviceModel, osType, osVersion)
            .then(resolve)
            .catch((err) => {
            setupInitializationErrorLogic(resolve, err.status);
        });
    });
};
const setupInitializationErrorLogic = (resolve, errorStatus, queryString) => {
    if (store) {
        store.dispatch({ type: INITIALIZATION_ERROR, initErrorStatus: errorStatus, queryString });
    }
    resolve();
};
const setupLoginLogic = (resolve, pageCtx) => {
    let url = '/login';
    if (pageCtx.querystring) {
        url = url.concat(`?${pageCtx.querystring}`);
    }
    pageCtx.page.redirect(url);
    resolve();
};
const setupProtectedPageInitialization = async (authSession, queryParams, forceCountry) => {
    const { app, country: countryParam, appVersion, deviceManufacturer, deviceModel, osType, osVersion, } = queryParams;
    const country = forceCountry ?? countryParam;
    await updateConfig(true, country, app, appVersion, deviceManufacturer, deviceModel, osType, osVersion);
    const patient = await getPatient(authSession.account_id, osType, osVersion, app, appVersion);
    store.dispatch({
        type: AUTH_SESSION,
        authSession: { ...authSession, include: { patient } },
    });
};
const protectedPageAction = (pageCtx) => {
    return new Promise((resolve) => {
        const queryParams = pageCtx.query;
        const authSession = getAuthSession();
        if (!queryParams) {
            setupInitializationErrorLogic(resolve, ApiStatus.BAD_REQUEST);
            return;
        }
        if (!authSession) {
            setupLoginLogic(resolve, pageCtx);
            return;
        }
        setupProtectedPageInitialization(authSession, queryParams)
            .then(resolve)
            .catch((err) => {
            const error = err;
            const code = error.response?.data.code;
            if (code === ApiStatus.WRONG_REGION) {
                const unsupportedCountry = error.response?.data.errors[0]?.unsupportedCountry;
                if (unsupportedCountry) {
                    setupProtectedPageInitialization(authSession, queryParams, unsupportedCountry)
                        .then(resolve)
                        .catch((err) => {
                        setupInitializationErrorLogic(resolve, err.status, pageCtx.querystring);
                    });
                    return;
                }
            }
            setupInitializationErrorLogic(resolve, err.status, pageCtx.querystring);
        });
    });
};
// Create your paths that you want to handle here
// you want to most specific earlier and the least specific later
// Note: if one action throws an error (calls promise reject) then the handlePaths
// will move onto the next matching route
const routeActions = [
    {
        regex: [
            /^\/account-information/i,
            /^\/update-password/i,
            /^\/rwe/i,
            /^\/hipaa/i,
            /^\/consents/i,
            /^\/notices-consents/i,
            /^\/assist/i,
        ],
        action: protectedPageAction,
    },
    {
        regex: [/^\.*/],
        action: root,
    },
];
export const handlePaths = (ctx) => {
    const doActions = [];
    for (const check of routeActions) {
        for (const r of check.regex) {
            if (ctx.canonicalPath.match(r)) {
                // Add valid actions to chain later
                doActions.push(check.action);
            }
        }
    }
    // Start with a rejected promise
    let p = Promise.reject();
    // Build a negative promise chain that will try the next action if the previous one failed
    // Once an action succeeds the chain ends and the app starts
    for (let i = 0; i < doActions.length; i++) {
        p = p.catch(() => doActions[i](ctx));
    }
    return p;
};
